var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("ProducerDetails", {
    attrs: {
      id: _vm.id,
      loggedUserData: _vm.loggedUserData,
      searchCriterias: _vm.searchCriterias,
      returnRoute: _vm.returnRoute,
      paramRoute: _vm.returnParam
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };